import React, { useState, useRef, useEffect } from "react";
import AnimeList from "../ViewAllMentorList/AnimeList";
import "./styles.scss";
import { Country, State } from "country-state-city";
import iconTooltip from "../../../../../assets/svg/dashboard/iconTooltip.svg";
import Modal from "../../StartupDashboard/MyRequests/Modal/modal";
import profile from "../../../../../assets/svg/dashboard/profile-iconRound.svg";
import { getNamesList } from "../../AdminDashboard/AdminMentorAction/dependencies/action";
import { getStepperTooltipData } from "../../AdminDashboard/AdminMentorAction/dependencies/action";
import { useHistory } from "react-router-dom";
import { getPredefineOptionsList } from "../../AdminDashboard/AdminMentorAction/dependencies/action";
import {
  getRequestfromMentorList,
  getStartupMentorshipCounter,
} from "../dependencies/action";
import LineWithDot from "../../MentorDashboard/MentorHome/img/Line wit Dot.svg";
import Pagination from "react-js-pagination";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import * as moment from "moment";
import Select from "react-select";
import hashImage from "../../../../../assets/images/hashImage.jpeg";
import swal from "sweetalert";
import api from "../../../../common/dependencies/utils/Api";
import { MENTORSHIP_STARTUP_APPLICATION_STATUS } from "../../../../common/constants/ApplicationUrl";
import Button from "../../AdminDashboard/Button";
import engagementIcon from "../../../../../assets/svg/dashboard/engagement-summary.svg";
import * as CryptoJS from "crypto-js";
import { PROFILE_KEY } from "../../../../common/constants/actionConstants";
const customStyles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "white",
    maxWidth: "185px",
    color: "rgb(121, 193, 206)",
    whiteSpace: "nowrap",
    fontSize: "16px",
  }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isSelected ? "#b499c7" : isFocused ? "#e4d7ee" : "white",
      color: isSelected ? "white" : "black",
      cursor: isDisabled ? "not-allowed" : "default",
      whiteSpace: "nowrap",
      textAlign: "left",
    };
  },
  menu: (base) => ({
    ...base,
    width: "max-content",
    minWidth: "100%",
    fontSize: "14px",
  }),
};

const approvalOptions = [
  {
    value: "Accept",
    label: "Accept",
  },
  { value: "Decline", label: "Decline" },
];
const MyMentorRequest = (props) => {
  class AesUtil {
    constructor(keySize, iterationCount) {
      this.keySize = keySize / 32;
      this.iterationCount = iterationCount;
    }
  
    generateKey = function (salt, passPhrase) {
      let key = CryptoJS.PBKDF2(passPhrase, CryptoJS.enc.Hex.parse(salt), {
        keySize: this.keySize,
        iterations: this.iterationCount,
      });
      return key;
    };
  
    encrypt = function (salt, iv, passPhrase, plainText) {
      let key = this.generateKey(salt, passPhrase);
      let encrypted = CryptoJS.AES.encrypt(plainText, key, {
        iv: CryptoJS.enc.Hex.parse(iv),
      });
      return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
    };
  }
  const encryptAES2 = (text, key) => {
    // let iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
    // let salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
  
    // let aesUtil = new AesUtil(128, 1000);
    // let ciphertext = aesUtil.encrypt(salt, iv, key, text);
  
    // let aesText = iv + "::" + salt + "::" + ciphertext;
    
    return btoa(text);
  };
  const html = document.getElementsByTagName("html")[0];
  let value = localStorage.getItem("SavedLoggedInData");
  let LoginData = JSON.parse(value);
  const {
    DashboardMentorMyRequestList,
    getPredefineOptionsList,
    getRequestfromMentorList,
    tableList,
    getPredefineOptions,

    mentorListData,
    mentorListDataPaginate,
    getStartupMentorshipCounterData,
    getStartupMentorshipCounter,
    getCounterMentor,
    getNamesListData,
    getNamesList,
    getStepperTooltipData,
    getStepperData,
  } = props;
  const currentRoute = window.location.href;
  let sample;
  sample = currentRoute.slice(0, currentRoute.lastIndexOf("/"));
  const callListFunction = (pageNumber) => {
    let params = {
      mentorId: LoginData.id,
      status: selectedStatus,
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 10,
        sortField: "id",
        sortOrder: "ASC",
      },
    };
  };
  useEffect(() => {
    html.style.overflow = "auto";

    localStorage.setItem("mentorStartupRequest", "mentorStartupRequest");
    setTimeout(() => {
      localStorage.removeItem("myRequests");
      localStorage.removeItem("startupAllMentorList");
      localStorage.removeItem("startUpRequests");
      localStorage.removeItem("CohortStartupRequest");
      localStorage.removeItem("cohortMentorshipsStartup");
    }, 1000);
    callListFunction(0);
  }, []);
  useEffect(() => {
    let params = {
      requestedBy: JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
    };
    getStartupMentorshipCounter(params);
  }, []);
  useEffect(() => {
    getStepperTooltipData();
  }, []);
  useEffect(() => {
    setHeading(getStepperData?.Guidedinstructions[0].Heading);
    setInstructionswithRole(
      getStepperData?.Guidedinstructions[0].InstructionswithRole
    );
    setSelectPage(getStepperData?.Guidedinstructions[0].SelectPage);
  }, [getStepperData]);
  useEffect(() => {
    if (history?.location?.state?.prevPage === undefined) {
      setActiveText(true);
      setActiveText2(false);
    } else if (history?.location?.state?.prevPage === "startupModal") {
      setActiveText2(true);
      setActiveText(false);
      setSelectedStatus("PENDING");
      getMentorApplications("PENDING");
      setActiveText2(true);
      setActiveText(false);
      setActiveText3(false);
      setActiveText4(false);
      setSelectedStatus("PENDING");
      getMentorApplications("PENDING");
      setTimeout(() => {
        history.location.state.prevPage = undefined;
      }, 2000);
    }
  }, []);
  const [Heading, setHeading] = useState();
  const [InstructionswithRole, setInstructionswithRole] = useState();
  const [SelectPage, setSelectPage] = useState();
  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState();
  const [indexCounter, setIndexCounter] = useState(0);
  const [activeText, setActiveText] = useState(false);
  const [activeText2, setActiveText2] = useState(false);
  const [activeText3, setActiveText3] = useState(false);
  const [activeText4, setActiveText4] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [filterIndustry, setFilterIndustry] = useState("");
  const [filterFunction, setFilterFunction] = useState("");
  const [filterStage, setFilterStage] = useState("");
  const [filterState, setFilterState] = useState("");
  const [filterCountry, setFilterCountry] = useState("");
  const [filterName, setFilterName] = useState("");
  const [nameListValue, setNameListValue] = useState([]);
  const newCountryArray = [];
  const newStateArray = [];
  const [newCountryOptions, setNewCountryOptions] = useState(newCountryArray);
  const [newStateOptions, setNewStateOptions] = useState(newStateArray);
  const [newCountrySelect, setNewCountrySelect] = useState(false);

  const [selectedStatus, setSelectedStatus] = useState("");
  const history = useHistory();
  const [isShown, setIsShown] = useState(false);
  const setModalIsOpenToTrue = () => {
    setIsShown(!isShown);
  };
  useEffect(() => {
    let params = {
      listKey: "MentorApplication",
    };
    getNamesList(params);
  }, []);
  const getMentorApplicationsName = (name) => {
    let params = {
      sortKey: "name",
      sortOrder: "ASC",
      country: filterCountry
        ? filterCountry == "Select Country"
          ? ""
          : filterCountry
        : null,
      state: filterState ? (filterState == "select" ? "" : filterState) : null, // optional
      industry: filterIndustry
        ? filterIndustry == "select"
          ? ""
          : filterIndustry
        : null, // optional
      function: filterFunction
        ? filterFunction == "select"
          ? ""
          : filterFunction
        : null, // optional
      stage: filterStage ? (filterStage == "select" ? "" : filterStage) : null, // optional
      // status: status,
      searchField: name === "Select" ? "" : name,
      status: selectedStatus,
      requestedBy: LoginData.id,
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 10,
        sortField: "id",
        sortOrder: "ASC",
      },
    };
    getRequestfromMentorList(params);
  };
  useEffect(() => {
    const indDefaultObject = {
      value: "select",
      label: "Select Country",
    };

    const indDefaultObject2 = {
      value: "select",
      label: "Select State",
    };

    Country.getAllCountries().map((item) => {
      const newObject = {
        value: item.isoCode,
        label: item.name,
      };

      newCountryArray.push(newObject);
      setNewCountryOptions(newCountryArray);
    });

    newCountryArray.unshift(indDefaultObject);
    State.getStatesOfCountry(newCountrySelect === true ? "IN" : null).map(
      (item) => {
        const newObject = {
          value: item.name,
          label: item.name,
        };

        newStateArray.push(newObject);
        setNewStateOptions(newStateArray);
      }
    );
    newStateArray.unshift(indDefaultObject2);
  }, [newCountrySelect]);
  const getMentorApplications = (status) => {
    let params = {
      sortKey: "name",
      sortOrder: "ASC",
      country: filterCountry
        ? filterCountry == "Select Country"
          ? ""
          : filterCountry
        : null,
      state: filterState ? (filterState == "select" ? "" : filterState) : null, // optional
      industry: filterIndustry
        ? filterIndustry == "select"
          ? ""
          : filterIndustry
        : null, // optional
      function: filterFunction
        ? filterFunction == "select"
          ? ""
          : filterFunction
        : null, // optional
      stage: filterStage ? (filterStage == "select" ? "" : filterStage) : null, // optional
      status: status,
      searchField: filterName === "Select" ? "" : filterName,
      requestedBy: LoginData.id,
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 10,
        sortField: "id",
        sortOrder: "ASC",
      },
    };
    getRequestfromMentorList(params);
  };
  useEffect(() => {
    if (getNamesListData !== undefined && getNamesListData !== null)
      getNamesListData?.forEach((element, index) => {
        if (index === 0) {
          let arr2 = {
            value: "Select",
            label: "Select Mentor",
          };
          setNameListValue((oldArray) => [...oldArray, arr2]);
        }
        let arr = {
          value: element.id,
          label: element.name,
        };
        if (getNamesListData.length >= nameListValue.length)
          setNameListValue((oldArray) => [...oldArray, arr]);
      });
  }, [getNamesListData]);
  useEffect(() => {
    callListFunction(0);
  }, [selectedStatus]);

  const setUpdateApplicationStatus = (status, searchId, mentorId) => {
    if (status != "Select") {
      let params = {
        searchId: searchId,
        mentorId: mentorId,
        status: status,
      };

      api
        .POST(`${MENTORSHIP_STARTUP_APPLICATION_STATUS}`, params)
        .then((response) => {
          const { data, status } = response || {};
          if (response === undefined) {
            swal({
              title: "WARNING",
              text: `Failed to  ` + params.status + ` Request `,
              icon: "info",
            }).then(function () {
              if (props.setRedirect !== undefined) {
                props.setRedirect("myRequests");
                history.push("/startup-dashboard");
              } else {
                localStorage.setItem("myRequests", "myRequests");
                window.location.reload();
              }
            });
            return false;
          }
          if (status === 200) {
            if (data?.errors.length > 0) {
              swal({
                title: "Info!",
                text: data?.errors[0]?.message,
                icon: "info",
              }).then(function () {
                localStorage.setItem(
                  "mentorStartupRequest",
                  "mentorStartupRequest"
                );
                window.location.reload();
              });
            } else
              swal({
                title: "Success",
                text: `Request Accepted Successfully `,
                icon: "success",
              }).then(function () {
                localStorage.setItem(
                  "mentorStartupRequest",
                  "mentorStartupRequest"
                );
                window.location.reload();
              });
            return response.data;
          } else {
            return { status: false };
          }
        })
        .catch((e) => {
          return Promise.reject(e);
        });
    }
  };
  const getMentorApplicationTable = (status) => {
    let params = {
      requestedBy: LoginData.id,
      status: status,
      pageFilter: {
        currentPage: 0,
        pageSize: 10,
      },
    };
    getRequestfromMentorList(params);
  };

  const redirectProfile = (item) => {
    let reRoute = window.open(sample + `/mentor-profile/${encryptAES2(item,PROFILE_KEY)}`, "_blank");
    // let reRoute = window.open(sample + `/mentor-profile/${item}`, "_blank");
    reRoute.id = item;
  };

  const defaultFormData = {
    search: "",
    industry: "",
    specialization: "",
    stage: "",
    recognized: "",
    state: "",
    country: "",
  };

  const [formData, setFormData] = useState(defaultFormData);

  useEffect(() => {
    getPredefineOptionsList();
  }, []);

  useEffect(() => {
    let params = {
      requestedBy: JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
      status: "",
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 10,
        sortField: "requestToMentorDate",
        sortOrder: "DESC",
      },
    };
    getRequestfromMentorList(params);
  }, [getRequestfromMentorList]);
  const getAppId = (string) => {
    const value = string.substring(string.length - 6);
    return value;
  };
  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
    let params = {
      sortKey: "name",
      sortOrder: "ASC",
      country: filterCountry
        ? filterCountry == "Select Country"
          ? ""
          : filterCountry
        : null,
      state: filterState ? (filterState == "select" ? "" : filterState) : null, // optional
      industry: filterIndustry
        ? filterIndustry == "select"
          ? ""
          : filterIndustry
        : null, // optional
      function: filterFunction
        ? filterFunction == "select"
          ? ""
          : filterFunction
        : null, // optional
      stage: filterStage ? (filterStage == "select" ? "" : filterStage) : null, // optional
      status: selectedStatus,
      searchField: filterName === "Select" ? "" : filterName,
      requestedBy: LoginData.id,
      pageFilter: {
        currentPage: pageNumber - 1,
        includeCount: true,
        pageSize: 10,
        sortField: "id",
        sortOrder: "ASC",
      },
    };
    getRequestfromMentorList(params);
  };
  return (
    <div className="requestFrom-startup mainstartupmobile">
      <div
        className="dashboard-main mentorshipreqfrommentorsdiv"
        style={{ background: "none" }}
      >
        <div className="iconWith-heading mentorshipreqfrommentorsappiconwith">
          <div style={{ width: "100%" }}>
            <h3
              className="fadeInDown wow TOP-head"
              style={{
                color: "#000",
                fontWeight: 600,
                fontSize: "28px",
              }}
            >
              MAARG Portal by Startup India
            </h3>
            <h2
              className="heading fadeInDown wow mentorshipreqfrommentorssecondheading"
              style={{ fontWeight: "600", marginTop: "10px" }}
            >
              MENTORSHIP REQUESTS FROM MENTORS
            </h2>
          </div>
          <div
            className="tooltipshow eyeIcon"
            style={{ paddingTop: "50px" }}
            // onClick={() => {
            //   // html.style.overflow = "hidden";

            //   if (html.style.overflow == "auto") {
            //     html.style.overflow = "hidden";
            //   } else {
            //     html.style.overflow = "auto";
            //   }
            // }}
          >
            <div className="newuserTooltip">
              <img
                className="iconbtn top-btn"
                src={iconTooltip}
                onClick={() => {
                  setModalIsOpenToTrue();
                  if (html.style.overflow == "auto") {
                    html.style.overflow = "hidden";
                  } else {
                    html.style.overflow = "auto";
                  }
                }}
                width={60}
              />{" "}
              <span
                className="tooltiptext tooltip-bottom "
                style={{ width: "130px", top: "50px", left: "20px" }}
              >
                View Instructions
              </span>
            </div>
          </div>
          {isShown && (
            <div>
              <AnimeList
                setModalIsOpenToTrue={setModalIsOpenToTrue}
                Heading={Heading}
                InstructionswithRole={InstructionswithRole}
                SelectPage={SelectPage}
              />
            </div>
          )}
        </div>
      </div>

      <Modal
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        modalData={modalData}
        hideData={true}
        modalType="intentMentor"
      />
      <div className="col-md-11 display-center mobileviewcohortappli">
        <div className="admin-bottom-cardNew row mobileviewmentorbelow">
          <div className="col-xs-6 col-sm-6 col-md-2 col-lg-2 mentorAppButton">
            <div className="dashboard-bottom-btn2">
              <p className="text-white2"> REQUEST STATUS</p>
            </div>
          </div>
          <div className="col-xs-6 col-sm-6 col-md-2 col-lg-2 totalReceivedBlock3 newuserTooltip">
            <p
              onClick={() => {
                setActiveText(true);
                setActiveText2(false);
                setActiveText3(false);
                setActiveText4(false);
                setSelectedStatus("");
                getMentorApplicationTable("");
                // getMentorApplications("");
              }}
              style={{
                color: activeText ? "#277acc" : "#838186",
                position: "relative",
              }}
              className="admindasheaderoptions d-flex justify-content-center"
            >
              REQUESTS RECEIVED :{" "}
              {getStartupMentorshipCounterData &&
                getStartupMentorshipCounterData.total}
            </p>
            <span
              className="tooltiptext   tooltip-bottom "
              style={{ left: "70px", width: "230px" }}
            >
              Click to View Requests Received
            </span>
            {activeText ? (
              <img className="requestStatusBar" src={LineWithDot} />
            ) : (
              ""
            )}
          </div>
          <div className="col-xs-6 col-sm-6 col-md-2 col-lg-2 totalReceivedBlock7 newuserTooltip">
            <p
              onClick={() => {
                setActiveText2(true);
                setActiveText(false);
                setActiveText3(false);
                setActiveText4(false);
                setSelectedStatus("PENDING");
                getMentorApplications("PENDING");
              }}
              style={{
                color: activeText2 ? "#277acc" : "#838186",
                position: "relative",
              }}
              className="admindasheaderoptions d-flex justify-content-center"
            >
              PENDING :{" "}
              {getStartupMentorshipCounterData &&
                getStartupMentorshipCounterData.pending}
            </p>
            <span
              className="tooltiptext tooltip-bottom "
              style={{ left: "65px", width: "230px" }}
            >
              Click to View Requests Pending
            </span>
            {activeText2 ? (
              <img className="requestStatusBar" src={LineWithDot} />
            ) : (
              ""
            )}
          </div>
          <div className="col-xs-6 col-sm-6 col-md-2 col-lg-2 totalPendingBlock4 newuserTooltip">
            <p
              onClick={() => {
                setActiveText3(true);
                setActiveText(false);
                setActiveText2(false);
                setActiveText4(false);
                setSelectedStatus("ACCEPTED");
                getMentorApplications("ACCEPTED");
                // getMentorApplications("PENDING");
              }}
              style={{ color: activeText3 ? "#277acc" : "#838186" }}
              className="admindasheaderoptions"
            >
              {" "}
              REQUESTS ACCEPTED :{" "}
              {getStartupMentorshipCounterData &&
                getStartupMentorshipCounterData.accepted}
            </p>
            <span
              className="tooltiptext   tooltip-bottom"
              style={{ left: "65px", width: "230px" }}
            >
              Click to View Requests Accepted
            </span>
            {activeText3 ? (
              <img className="requestStatusBar" src={LineWithDot} />
            ) : (
              ""
            )}
          </div>
          <div className="col-xs-6 col-sm-6 col-md-2 col-lg-2 totalPendingBlock5 newuserTooltip">
            <p
              onClick={() => {
                setActiveText3(false);
                setActiveText(false);
                setActiveText2(false);
                setActiveText4(true);
                setSelectedStatus("REJECTED");
                getMentorApplications("REJECTED");
                // getMentorApplications("VERIFIED");
              }}
              style={{ color: activeText4 ? "#277acc" : "#838186" }}
              className="admindasheaderoptions"
            >
              {" "}
              REQUESTS DECLINED :{" "}
              {getStartupMentorshipCounterData &&
                getStartupMentorshipCounterData.rejected}
            </p>
            <span
              className="tooltiptext   tooltip-bottom"
              style={{ left: "65px", width: "230px" }}
            >
              Click to View Requests Declined
            </span>
            {activeText4 ? (
              <img className="requestStatusBar" src={LineWithDot} />
            ) : (
              ""
            )}
          </div>
        </div>
        <div className="filter-row filter-row-common filterDivMentorapp">
          {/* <div className="container"> */}
          <div>
            <form className="formContainer newfilterdivnow">
              <div className="row desktopFilterRow">
                <div className="col-11 d-flex justify-content-around startUpReqAlign">
                  <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix newuserTooltip allstartuplistforsame">
                    <Select
                      required={true}
                      id="searchBy"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="searchBy"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.name}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            name: e.name == "select" ? null : e,
                          };
                        });
                        setFilterName(e.value);
                        getMentorApplicationsName(e.value);
                      }}
                      options={nameListValue.length > 0 ? nameListValue : ""}
                      placeholder="Mentor Name"
                    />
                    <span
                      className="tooltiptext tooltip-bottom"
                      style={{ left: "77px", top: "45px", width: "200px" }}
                    >
                      Search Mentor Name
                    </span>
                  </div>

                  <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix newuserTooltip allstartuplistforsame">
                    <Select
                      required={true}
                      id="Industry"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="industry"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.industry}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            industry: e.value == "select" ? null : e,
                          };
                        });
                        setFilterIndustry(e.value);
                      }}
                      options={getPredefineOptions?.industry_options}
                      placeholder="Industry"
                    />
                    <span
                      className="tooltiptext tooltip-bottom"
                      style={{ left: "77px", top: "45px", width: "130px" }}
                    >
                      Search Industry
                    </span>
                  </div>
                  <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix newuserTooltip allstartuplistforsame">
                    <Select
                      required={true}
                      id="specialization"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="specialization"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.function}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            function: e.value == "select" ? null : e,
                          };
                        });
                        setFilterFunction(e.value);
                      }}
                      options={getPredefineOptions?._specialisation}
                      placeholder="Function"
                    />
                    <span
                      className="tooltiptext tooltip-bottom"
                      style={{ left: "77px", top: "45px", width: "130px" }}
                    >
                      Search Function
                    </span>
                  </div>

                  <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix newuserTooltip allstartuplistforsame">
                    <Select
                      required={true}
                      id="stage"
                      // label="Gender*"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="stage"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.stage}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            stage: e.value == "select" ? null : e,
                          };
                        });
                        setFilterStage(e.value);
                      }}
                      options={getPredefineOptions?.stage_of_startup_options}
                      placeholder="Stage"
                    />
                    <span
                      className="tooltiptext tooltip-bottom"
                      style={{ left: "77px", top: "45px", width: "130px" }}
                    >
                      Search Stage
                    </span>
                  </div>
                  <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix newuserTooltip allstartuplistforsame">
                    <Select
                      required={true}
                      id="country"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="country"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.country}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            country: e.value == "select" ? null : e,
                          };
                        });

                        setFilterCountry(e.label);

                        if (e.label === "India") {
                          setNewCountrySelect(true);
                        } else {
                          setNewCountrySelect(false);
                          setFormData((user) => {
                            return {
                              ...user,
                              state: "",
                            };
                          });
                        }
                        setNewStateOptions("");
                      }}
                      options={newCountryOptions}
                      placeholder="Country"
                    />
                    <span
                      className="tooltiptext tooltip-bottom"
                      style={{ left: "77px", top: "45px", width: "130px" }}
                    >
                      Search Country
                    </span>
                  </div>
                  <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix newuserTooltip">
                    <Select
                      required={true}
                      id="state"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="state"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.state}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            state: e.value == "select" ? null : e,
                          };
                        });
                        setFilterState(e.value);
                      }}
                      options={newStateOptions}
                      placeholder="State"
                    />
                    <span
                      className="tooltiptext tooltip-bottom"
                      style={{ left: "77px", top: "45px", width: "130px" }}
                    >
                      Search State
                    </span>
                  </div>
                </div>

                <div className="col-1 apply-section goButtonFix newuserTooltip">
                  <Button
                    onClick={() => getMentorApplications(selectedStatus)}
                    text="GO"
                    className="filter-button top-btn newcoloredbtn"
                  ></Button>
                  <span
                    className="tooltiptext   tooltip-bottom"
                    style={{
                      left: "46px",
                      width: "126px",
                      height: "48px",
                      top: "42px",
                    }}
                  >
                    Click to Apply Filters
                  </span>
                </div>
              </div>

              <div className="row mobileFilterRow">
                <div className="col-11 justify-content-around innermobilefilter">
                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="Industry"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="industry"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.industry}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            industry: e.value == "select" ? null : e,
                          };
                        });
                        setFilterIndustry(e.value);
                      }}
                      options={getPredefineOptions?.industry_options}
                      placeholder="Industry"
                    />
                  </div>
                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="specialization"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="specialization"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.function}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            function: e.value == "select" ? null : e,
                          };
                        });
                        setFilterFunction(e.value);
                      }}
                      options={getPredefineOptions?._specialisation}
                      placeholder="Function"
                    />
                  </div>

                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="stage"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="stage"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.stage}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            stage: e.value == "select" ? null : e,
                          };
                        });
                        setFilterStage(e.value);
                      }}
                      options={getPredefineOptions?.stage_of_startup_options}
                      placeholder="Stage"
                    />
                  </div>
                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="country"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="country"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.country}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            country: e.value == "select" ? null : e,
                          };
                        });

                        setFilterCountry(e.label);

                        if (e.label === "India") {
                          setNewCountrySelect(true);
                          setFilterState("");
                        } else {
                          setNewCountrySelect(false);
                          setFilterState("");
                          setFormData((user) => {
                            return {
                              ...user,
                              state: "",
                            };
                          });
                        }
                        setNewStateOptions("");
                      }}
                      options={newCountryOptions}
                      placeholder="Country"
                    />
                  </div>

                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="state"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="state"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.state}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            state: e.value == "select" ? null : e,
                          };
                        });
                        setFilterState(e.value);
                      }}
                      options={newStateOptions}
                      placeholder="State"
                    />
                  </div>
                  <div
                    className="col-md-1 apply-section d-flex justify-content-end"
                    style={{ color: "transparent" }}
                  >
                    <Button
                      className="green-btn filter-btn"
                      onClick={() => getMentorApplications(selectedStatus)}
                      text="GO"
                    />
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div className="totalTableCount">
          Total Records Found :{" "}
          {mentorListDataPaginate !== undefined
            ? mentorListDataPaginate?.totalElements
            : "0"}{" "}
          &lt;
          {mentorListDataPaginate !== undefined
            ? mentorListDataPaginate?.currentPage
            : "0"}{" "}
          of{" "}
          {mentorListDataPaginate !== undefined
            ? mentorListDataPaginate?.numPages
            : "0"}{" "}
          &gt;{" "}
        </div>
        {tableList !== null &&
        tableList !== undefined &&
        tableList?.length > 0 ? (
          <div
            style={{
              marginTop: "1%",
              marginBottom: "3%",
            }}
          >
            <table
              className="table table-bordered"
              style={{ fontSize: "16px" }}
            >
              <thead>
                <tr>
                  <th
                    style={{ verticalAlign: "middle" }}
                    className="fixColumbnWidth4"
                  >
                    NO.
                  </th>
                  <th
                    style={{ verticalAlign: "middle" }}
                    className="fixTableHeading"
                    colspan="2"
                  >
                    MENTOR
                  </th>
                  <th style={{ verticalAlign: "middle" }}>REQUEST ID</th>
                  <th style={{ width: "30%", verticalAlign: "middle" }}>
                    PURPOSE OF REQUEST
                  </th>
                  <th style={{ verticalAlign: "middle" }}>REQUEST STATUS</th>
                </tr>
              </thead>

              <tbody>
                {tableList.map((item, index) => (
                  <tr
                    key={index}
                    className={
                      item.id === indexCounter ? "purpleBackground" : ""
                    }
                  >
                    {mentorListDataPaginate?.currentPage === 1 ? (
                      <td>
                        {" "}
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            fontWeight: "normal",
                            alignItems: "center",
                          }}
                        >
                          {index + 1}
                        </div>
                      </td>
                    ) : (
                      <td>
                        {index +
                          1 +
                          10 * (mentorListDataPaginate?.currentPage - 1)}
                      </td>
                    )}
                    <td
                      className="increaseheight"
                      style={
                        {
                          // display: "flex",
                          // justifyContent: "center",
                        }
                      }
                    >
                      
                      <div
                        className="newuserTooltip "
                        style={{
                          width: "100px",
                          height: "100px",
                          maxWidth: "none",
                          objectFit: "contain",
                        }}
                      >
                        <img
                          src={
                            item.mentorProfilePic === null
                              ? hashImage
                              : item.mentorProfilePic
                          }
                          onClick={() => {
                            setIndexCounter(item.id);
                            redirectProfile(item?.mentorId);
                          }}
                          className="sidebar-dashboard-icon2"
                          style={{
                            width: "100%",
                            cursor: "pointer",
                            height: "100%",
                            objectFit: "contain",
                          }}
                        />
                        <span
                          className="tooltiptext tooltip-bottom"
                          style={{ top: "85px", left: "26px", width: "150px" }}
                        >
                          View Mentor Profile
                        </span>
                        <p className="uniquepara">{item.mentorName}</p>
                        <div
                          className="d-flex justify-content-end newuserTooltip viewprofilemnto"
                          style={{
                            cursor: "pointer",
                            alignItems: "end",
                            justifyContent: "center",
                            float: "right",

                            width: "40px",
                            display: "flex",
                          }}
                          onClick={() => {
                            setIndexCounter(item.id);
                            redirectProfile(item?.mentorId);
                          }}
                        >
                          <img src={profile} />

                          <span
                            className="tooltiptext tooltip-bottom"
                            style={{
                              top: "108px",
                              left: "10px",
                              width: "150px",
                            }}
                          >
                            View Mentor Profile
                          </span>
                        </div>
                      </div>
                    </td>
                    <td
                      style={{ minWidth: "300px" }}
                      className="mentoridhideid"
                    >
                      <div
                        style={{
                          flexDirection: "row",
                          display: "flex",
                          justifyContent: "space-between",
                          height: "100px",
                        }}
                      >
                        {" "}
                        <div
                          style={{
                            cursor: "default",
                            alignItems: "center",
                            display: "flex",
                            maxWidth: "240px",
                          }}
                        >
                          {item.mentorName}
                        </div>
                        <div
                          className="d-flex justify-content-end newuserTooltip "
                          style={{
                            cursor: "pointer",
                            alignItems: "end",
                            justifyContent: "center",

                            width: "40px",
                            display: "flex",
                          }}
                          onClick={() => {
                            setIndexCounter(item.id);
                            redirectProfile(item?.mentorId);
                          }}
                        >
                          <img src={profile} />

                          <span
                            className="tooltiptext tooltip-bottom"
                            style={{
                              top: "108px",
                              left: "10px",
                              width: "150px",
                            }}
                          >
                            View Mentor Profile
                          </span>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div
                        className="newuserTooltip requirement100"
                        style={{ paddingTop: "10px", marginBottom: "-20px" }}
                      >
                        <a
                          onClick={() => {
                            setIndexCounter(item.requestId);
                            setModalData(item.requestJson);
                            setModalOpen(true);
                            // ViewMentorApplicaiton(item);
                          }}
                          className="color-green "
                        >
                          {getAppId(item.searchId)}
                        </a>
                        <span className="tooltiptext mentoricon tooltip-bottom ">
                          View Requirement
                        </span>
                        <span className="datehidemb">
                          {moment(item.requestToMentorDate).format(
                            "DD/MM/YYYY "
                          )}
                          <br />
                          {moment(item.requestToMentorDate).format(" hh:mm A")}
                        </span>
                      </div>
                      <br />
                      <span className="hideformbnotdesk">
                        {moment(item.requestToMentorDate).format("DD/MM/YYYY ")}
                        <br />
                        {moment(item.requestToMentorDate).format(" hh:mm A")}
                      </span>
                    </td>

                    {item?.purposeOfMentorship?.length > 130 ? (
                      <td>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            height: "100px",
                            alignItems: "center",
                          }}
                        >
                          {" "}
                          <div className="tooltipicon ">
                            {item?.purposeOfMentorship.substring(0, 130)}
                            <svg
                              style={{
                                position: "relative",
                                top: "0.1rem",
                              }}
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              fill="currentColor"
                              class="bi bi-three-dots"
                              viewBox="0 0 16 16"
                            >
                              <path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" />
                            </svg>
                            <span className="tooltiptext7">
                              <h5 style={{ color: "#fff" }}>
                                Purpose of Request
                              </h5>
                              {item?.purposeOfMentorship}
                            </span>
                          </div>
                        </div>
                      </td>
                    ) : (
                      <td>
                        {" "}
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            height: "100px",
                            alignItems: "center",
                          }}
                        >
                          {item?.purposeOfMentorship}
                        </div>
                      </td>
                    )}
                    {item.requestStatus === "Accepted" ? (
                      <td>
                        <div
                          className="showdatainrow"
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            height: "100px",
                            alignItems: "center",
                          }}
                        >
                          <div style={{ width: "80%" }}>
                            {item.requestStatus}
                          </div>{" "}
                          <div
                            className="d-flex justify-content-end newuserTooltip"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              if (item?.mentorshipId !== null) {
                                setIndexCounter(item.id);

                                window.open(
                                  `/startup-dashboard/mentorships/engagement-summary/${item?.mentorshipId}`,
                                  "_blank"
                                );
                              } else {
                                props.setSelectedMenu("mentorMentorships");
                                history.push("/dashboard");
                              }
                            }}
                          >
                            <img
                              style={{
                                height: "40px",
                                minWidth: "40px",
                                marginTop: "35px",
                              }}
                              src={engagementIcon}
                              alt={item.title}
                            />
                            <span
                              className="tooltiptext tooltip-textBotooom text-bottom"
                              style={{
                                top: "80px",
                                left: "-96px",
                                width: "140px",
                                height: "50px",
                              }}
                            >
                              View Engagement Summary
                            </span>
                          </div>
                        </div>
                      </td>
                    ) : item.requestStatus === "Declined" ? (
                      <td>
                        {" "}
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            height: "100px",
                            alignItems: "center",
                          }}
                        >
                          {item.requestStatus}
                        </div>
                      </td>
                    ) : (
                      <td className="applicationStatusMentorapp">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            height: "100px",
                            alignItems: "center",
                          }}
                        >
                          <div className="rowC">
                            <Select
                              required={true}
                              id="Status"
                              variant="outlined"
                              fullWidth
                              margin="normal"
                              type="State"
                              name="Status"
                              className="col-12 "
                              styles={customStyles}
                              isSearchable={false}
                              onChange={(e) => {
                                setUpdateApplicationStatus(
                                  e.value,
                                  item.searchId,
                                  item.mentorId
                                );
                              }}
                              options={approvalOptions}
                              placeholder="Select"
                            />
                          </div>
                        </div>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="pagination-box">
              {mentorListData ? (
                <Pagination
                  activePage={activePage}
                  itemsCountPerPage={10}
                  totalItemsCount={mentorListDataPaginate?.totalElements}
                  pageRangeDisplayed={5}
                  onChange={handlePageChange.bind(this)}
                />
              ) : (
                ""
              )}
            </div>
          </div>
        ) : (
          <div className="no-records">No Records Found</div>
        )}
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
    mentorListData: state.MentorReducer.MentorApplicationList,
    mentorListDataPaginate:
      state.StartUpReducer.getRequestfromMentorList.paginate,
    getCounterMentor: state.MentorReducer.getCountersMentorList.data,
    getNamesListData: state.AdminMentorReducer.getNamesList?.data,
    tableList: state.StartUpReducer.getRequestfromMentorList.data,
    getStartupMentorshipCounterData:
      state.StartUpReducer.startUpMentorshipCounter.data,
    getStepperData: state.AdminMentorReducer.getStepperList.list,
  };
};

export default connect(mapStateToProps, {
  getPredefineOptionsList,
  getNamesList,
  getStartupMentorshipCounter,
  getRequestfromMentorList,
  getStepperTooltipData,
})(withRouter(MyMentorRequest));
